<div style="max-width: 1400px; margin: 0 auto; padding: 16px;">

  <!-- ═══ Header ═══ -->
  <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 16px;">
    <div style="display: flex; align-items: center; gap: 10px; padding: 16px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5);">
      <mat-icon style="color: #1e5a3f; font-size: 28px; width: 28px; height: 28px;">verified_user</mat-icon>
      <span style="color: #1e5a3f; font-weight: 700; font-size: 1.3rem;">Compliance</span>
      <span *ngIf="dataSource"
        style="background: #dcfce7; color: #1e5a3f; font-size: 0.8rem; padding: 2px 10px; border-radius: 10px; font-weight: 600;">
        {{ dataSource.filteredData.length }} registros
      </span>
    </div>
  </div>

  <!-- ═══ Search & Filter ═══ -->
  <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 16px;">
    <div style="padding: 16px 20px; background: white;">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Buscar</mat-label>
          <mat-icon matPrefix style="color: #6b7280;">search</mat-icon>
          <input matInput type="text" (keyup)="doFilter($event)" placeholder="Nombre, email, documento...">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Filtrar por estado</mat-label>
          <mat-select (selectionChange)="doFilter($event.value)">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let option of filterOptions" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- ═══ Paginator ═══ -->
  <div style="display: flex; justify-content: center; margin-bottom: 12px;">
    <mat-paginator
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      showFirstLastButtons
      itemsPerPageLabel="itemsPerPageLabel"
      previousPageLabel="previousPageLabel"
      nextPageLabel="nextPageLabel"
      firstPageLabel="firstPageLabel"
      lastPageLabel="lastPageLabel"
      [pageSize]="defaultPageSize"
      style="border-radius: 8px; border: 1px solid #d1d5db;">
    </mat-paginator>
  </div>

  <!-- ═══ Desktop Table ═══ -->
  <div class="hidden lg:block" style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden;">
    <div style="overflow-x: auto;">
      <mat-table [dataSource]="dataSource" *ngIf="dataSource" class="compliance-table">
        <ng-container
          *ngFor="let column of columns"
          [matColumnDef]="column.columnDef"
        >
          <mat-header-cell *matHeaderCellDef [ngStyle]="column.headerStyle">
            {{ column.header }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" [ngStyle]="column.cellStyle">
            <ng-container *ngIf="column.columnDef === 'estado_compliance' && column.iconColor; else otherColumns">
              <mat-icon [style.color]="column.iconColor(row)" [matTooltip]="column.val(row)"
                style="font-size: 20px; width: 20px; height: 20px;">{{ column.cell(row) }}</mat-icon>
            </ng-container>
            <ng-template #otherColumns>
              {{ column.cell(row) }}
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="acciones" stickyEnd>
          <mat-header-cell *matHeaderCellDef
            style="text-align: center; font-weight: bold; min-width: 70px;">
            Acciones
          </mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center; min-width: 120px;">
            <div style="display: inline-flex; align-items: center; gap: 6px;">
              <button
                (click)="toggleCanAddPayers(element, $event)"
                [disabled]="!puedeToggle(element)"
                [matTooltip]="!puedeToggle(element) ? 'Solo clientes aprobados pueden gestionar pagadores' : (element.canAddPayers ? 'Creación de pagadores habilitada (clic para deshabilitar)' : 'Creación de pagadores deshabilitada (clic para habilitar)')"
                [style.opacity]="puedeToggle(element) ? 1 : 0.4"
                [style.cursor]="puedeToggle(element) ? 'pointer' : 'not-allowed'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
                  [style.color]="element.canAddPayers ? '#1C593D' : '#9ca3af'">
                  {{ element.canAddPayers ? 'toggle_on' : 'toggle_off' }}
                </mat-icon>
              </button>
              <button [routerLink]="['/wallet/admin/compliance', element.email]"
                matTooltip="Ver detalle"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">visibility</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"
          [routerLink]="['/wallet/admin/compliance', row.email]"
          style="cursor: pointer;"></mat-row>
      </mat-table>
    </div>
  </div>

  <!-- ═══ Mobile / Tablet Cards ═══ -->
  <div class="lg:hidden">
    <div *ngIf="!dataSource || dataSource.filteredData.length === 0"
      style="text-align: center; padding: 40px 20px;">
      <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">people_outline</mat-icon>
      <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron registros</p>
    </div>

    <div *ngFor="let row of currentPageData"
      style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 10px;">
      <!-- Card header -->
      <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; background: #f9fafb; border-bottom: 1px solid #f3f4f6;">
        <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
          <span style="background: #dcfce7; color: #1e5a3f; font-size: 0.75rem; padding: 2px 8px; border-radius: 10px; font-weight: 600;">
            #{{ row.id }}
          </span>
          <span style="font-size: 0.7rem; padding: 2px 8px; border-radius: 10px; font-weight: 600; color: white;"
            [style.background]="row.tipoUsuario === 'PERSONA' ? '#3b82f6' : '#8b5cf6'">
            {{ row.tipoUsuario }}
          </span>
          <span style="font-size: 0.7rem; padding: 2px 8px; border-radius: 10px; font-weight: 600;"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)">
            <mat-icon [style.color]="getStatusColor(row)"
              style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; margin-right: 2px;">
              {{ getStatusIcon(row) }}
            </mat-icon>
            {{ row.estadoCompliance }}
          </span>
        </div>
        <button [routerLink]="['/wallet/admin/compliance', row.email]"
          style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">visibility</mat-icon>
        </button>
      </div>
      <!-- Card body -->
      <div style="padding: 12px 16px; background: white;">
        <div class="grid grid-cols-2 gap-x-12 gap-y-1">
          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Nombre</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ getUserName(row) }}</span>
          </div>
          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Documento</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ getUserDocument(row) }}</span>
          </div>
          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Email</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem; word-break: break-all;">{{ row.email }}</span>
          </div>
          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">País</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ row.paisResidencia || '-' }}</span>
          </div>
          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Creación</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.8rem;">{{ getDateStr(row, 'creacion') }}</span>
          </div>
        </div>
        <!-- Compliance flags -->
        <div style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px;">
          <span *ngIf="row.esPoliticamenteExpuesto"
            style="font-size: 0.7rem; padding: 2px 8px; border-radius: 10px; font-weight: 600;"
            [style.background]="row.esPoliticamenteExpuesto === 'SI' || row.esPoliticamenteExpuesto === true ? '#fef2f2' : '#f3f4f6'"
            [style.color]="row.esPoliticamenteExpuesto === 'SI' || row.esPoliticamenteExpuesto === true ? '#dc2626' : '#6b7280'">
            PEP: {{ row.esPoliticamenteExpuesto }}
          </span>
          <span *ngIf="row.esRTP"
            style="font-size: 0.7rem; padding: 2px 8px; border-radius: 10px; font-weight: 600;"
            [style.background]="row.esRTP === 'SI' || row.esRTP === true ? '#fef2f2' : '#f3f4f6'"
            [style.color]="row.esRTP === 'SI' || row.esRTP === true ? '#dc2626' : '#6b7280'">
            RTP: {{ row.esRTP }}
          </span>
          <span *ngIf="row.esListaONU"
            style="font-size: 0.7rem; padding: 2px 8px; border-radius: 10px; font-weight: 600;"
            [style.background]="row.esListaONU === 'SI' || row.esListaONU === true ? '#fef2f2' : '#f3f4f6'"
            [style.color]="row.esListaONU === 'SI' || row.esListaONU === true ? '#dc2626' : '#6b7280'">
            ONU: {{ row.esListaONU }}
          </span>
          <span *ngIf="getResponsable(row) !== 'N/A'"
            style="font-size: 0.7rem; padding: 2px 8px; border-radius: 10px; font-weight: 600; background: #eff6ff; color: #1d4ed8;">
            {{ getResponsable(row) }}
          </span>
        </div>
      </div>
    </div>
  </div>

</div>
